<template lang="pug">
  #modelView(:style='boxStyle')
    modelFileName(ref="modelFileName" v-if="modelLoaded")
    splitpanes.default-theme(:dbl-click-splitter="false")
      pane.column-left(v-if='hasDwg',min-size="30",max-size="70",v-resize)
        application(ref='dwgApplication' type="modelDwg" key="modelDwg")
        i(class="el-icon-close",title="关闭",@click="closeMap")
        #dwgbox.viewDwg
      pane.column-right(v-resize)
        application(ref="modelApplication" v-if="modelLoaded" type="model" key="model")
        #modelbox.viewModel(ref="modelbox",@contextmenu.prevent="onContextmenu")
  </template>

<script>
import mongeService from "@/CommonDP/mongeView/service/monge-service.js";
import fileService from "@/CommonDP/service/file-service";
import modelFileName from "./modelFileName.vue";
import mongeApiMlib from "@/CommonDP/mongeView/mongeApiMlib";
import application from "@/CommonDP/mongeView/application.vue";
import { mongeApp, mongeMutations } from "@/CommonDP/mongeView/store/mongeStore";
import { isNoLightweightModel, noLightweightUrl } from "@/CommonDP/mongeView/utils";
import { Splitpanes, Pane } from 'splitpanes';
import 'splitpanes/dist/splitpanes.css';
import { debounce } from "lodash";
const obz = new ResizeObserver(debounce(mongeApiMlib.resize), 100);

export default {
  directives: {
    resize: {
      inserted(el) {
        obz.observe(el);
      },
      unbind(el) {
        obz.unobserve(el);
      }
    }
  },
  components: { application, Splitpanes, Pane, modelFileName },
  data () {
    return {
      modelLoaded: false
    };
  },
  computed: {
    mlibEnabled() {
      return mongeApp.mlibEnabled;
    },
    modelInfoData() {
      return JSON.parse(mongeApp.model.fileInfo);
    },
    hasDwg() {
      return mongeApp.model.hasDwg;
    },
    hasList() {
      return mongeApp.hasList;
    },
    boxStyle() {
      return this.hasList ? { width: "calc(100% - 300px)" } : { width: "100%" };
    }
  },
  created () {
    this.getFileInfo();
  },
  beforeDestroy() {
    mongeMutations.setHasDwg(false);
    mongeMutations.setModelPageFileName();
    mongeMutations.openModelReady(false);
    mongeMutations.setIsNoLightweight(false);
  },
  methods: {
    async getFileInfo() {
      const { fileIds = "", versionIds = "", i = "" } = this.$route.query;
      mongeMutations.setShareId(i);
      if (!fileIds) {
        return Promise.reject("没有文件id，无法获取文件信息");
      }
      const fId = fileIds.split(",");
      const rVersion = versionIds.split(",");
      mongeMutations.clearUrlFileIdList();
      if (fId.length === 1) { // 单模型
        const { data } = await mongeService.getFileDetails(fId[0], i);
        document.title = data.fileName;
        const modeldatas = { fileId: data.fileId, fileName: data.fileName, prjId: data.prjId, rvtVersion: rVersion[0], fileType: data.fileType };
        mongeMutations.setModelInfo(JSON.stringify(modeldatas));
      } else { // 多模型
        const fileObj = [];
        let prjId = "";
        for (const [index, value] of fId.entries()) {
          const { data } = await mongeService.getFileDetails(value, i);
          prjId = data.prjId;
          const fileType = data.fileType;
          const obj = { folderID: data.fileId, folderName: data.fileName, rvtVersion: rVersion[index], fileType };
          fileObj.push(obj);
        }
        document.title = fileObj.map(e => e.folderName).join();
        const modeldatas = { fileObj, prjId };
        mongeMutations.setModelInfo(JSON.stringify(modeldatas));
      }
      this.loadModelFromMLib();
    },
    async loadModelFromMLib() {
      await this.queryConvertMode();
      if (this.modelInfoData.fileObj) { // 多文件
        this.multiModels();
      } else if (this.modelInfoData.fileId) { // 单文件
        this.singleModel();
      }
    },
    // 查看模型的加载方式
    async queryConvertMode() {
      try {
        if (this.modelInfoData.fileObj) { // 多文件
          const modelsArray = this.modelInfoData.fileObj;
          const resList = [];
          for (const iterator of modelsArray) {
            if (!isNoLightweightModel(iterator.fileType)) {
              const res = await mongeService.queryConvertMode(iterator.folderID, iterator.rvtVersion);
              resList.push(res.data === 1 ? "new" : "old");
            }
          }
          const mlibEnabled = Array.from(new Set(resList));
          mongeMutations.changeMlibEnabled(mlibEnabled[0] === "new");
          if (mlibEnabled.length > 1) {
            this.$error("新旧模型不能整合");
            setTimeout(() => {
              window.close();
            }, 3000);
          }
        } else if (this.modelInfoData.fileId) {
          if (!isNoLightweightModel(this.modelInfoData.fileType)) {
            const res = await mongeService.queryConvertMode(this.modelInfoData.fileId, this.modelInfoData.rvtVersion || '');
            mongeMutations.changeMlibEnabled(!!(res.data && res.data === 1));
          }
        }
      } catch (e) {
        mongeMutations.changeMlibEnabled(false);
      }
      return Promise.resolve();
    },
    // 整合模型组装url
    async multiModels() {
      const modelsArray = this.modelInfoData.fileObj;
      let modelUrlInfoList = [];
      if (this.mlibEnabled) {
        for (const item of modelsArray) {
          const rvtId = item.folderID;
          const rvtVersion = item.rvtVersion || "";
          if (!isNoLightweightModel(item.fileType)) {
            try {
              const res = await mongeService.queryModelLightFilesFromMLib(rvtId, rvtVersion);
              const array = mongeApiMlib.dealMongeModelFiles(res.data);
              const obj = { fileId: rvtId, rvtVersion, url: array };
              mongeMutations.setUrlFileIdList(obj);
              modelUrlInfoList = [...modelUrlInfoList, ...array];
            } catch (error) {
              this.$error("未获取模型id");
            }
          }
        }
        this.loadModel(modelUrlInfoList);
      } else {
        for (const item of modelsArray) {
          const rvtId = item.folderID;
          const rvtVersion = item.rvtVersion || "";
          if (!isNoLightweightModel(item.fileType)) {
            try {
              const res = await mongeService.queryModelUrlList(rvtId, rvtVersion);
              const list = mongeApiMlib.assembleModelUrl(res.data);
              const obj = { fileId: rvtId, rvtVersion, url: list };
              mongeMutations.setUrlFileIdList(obj);
              modelUrlInfoList = [...modelUrlInfoList, ...list];
            } catch (error) {
              this.$error("未获取模型id");
            }
          }
        }
        this.loadModel(modelUrlInfoList);
      }
    },
    // 单模型组装url
    async singleModel() {
      const rvtId = this.modelInfoData.fileId;
      const rvtVersion = this.modelInfoData.rvtVersion || "";
      const fileType = this.modelInfoData.fileType;
      if (isNoLightweightModel(fileType)) {
        const url = noLightweightUrl(this.modelInfoData.prjId, rvtId, rvtVersion);
        this.loadNoLWModel(url, fileType);
      } else {
        try {
          if (this.mlibEnabled) {
            const res = await mongeService.queryModelLightFilesFromMLib(rvtId, rvtVersion);
            mongeMutations.setAllFileList(res.data.lightFileList || []);
            const modelUrlInfoList = mongeApiMlib.dealMongeModelFiles(res.data);
            if (!modelUrlInfoList) {
              this.$error("模型轻量化失败");
              return false;
            }
            const obj = { fileId: rvtId, rvtVersion, url: modelUrlInfoList };
            mongeMutations.setUrlFileIdList(obj);
            this.loadModel(modelUrlInfoList);
          } else {
            const res = await mongeService.queryModelUrlList(rvtId, rvtVersion);
            const modelUrlInfoList = mongeApiMlib.assembleModelUrl(res.data);
            const obj = { fileId: rvtId, rvtVersion, url: modelUrlInfoList };
            mongeMutations.setUrlFileIdList(obj);
            this.loadModel(modelUrlInfoList);
          }
        } catch (error) {
          this.$error("轻量化失败");
        }
      }
    },
    // 不需要轻量化的模型
    // async loadNoLW() {
    //   if (this.modelInfoData.fileObj) { // 多文件
    //     const modelsArray = this.modelInfoData.fileObj;
    //     for (const item of modelsArray) {
    //       if (isNoLightweightModel(item.fileType)) {
    //         const url = noLightweightUrl(this.modelInfoData.prjId, item.folderID, item.rvtVersion);
    //         this.loadNoLWModel(url, "modelbox");
    //       }
    //     }
    //   } else if (this.modelInfoData.fileId) {
    //     if (isNoLightweightModel(this.modelInfoData.fileType)) {
    //       const url = noLightweightUrl(this.modelInfoData.prjId, this.modelInfoData.fileId, this.modelInfoData.rvtVersion);
    //       this.loadNoLWModel(url, "modelbox");
    //     }
    //   }
    // },
    // 加载不需要轻量化的模型
    async loadNoLWModel(urlList, fileType) {
      await mongeApiMlib.loadNoLightweightModel(urlList, "modelbox", fileType);
      await this.recentViewRecordAdd();
      this.modelLoaded = true;
    },
    async recentViewRecordAdd() {
      const fileId = this.modelInfoData.fileId;
      const fileVersion = this.modelInfoData.rvtVersion || "";
      await fileService.recentViewRecordAdd(fileId, fileVersion);
    },
    // 加载模型
    async loadModel(urlList) {
      if (urlList) {
        await mongeApiMlib.loadModel(urlList, "modelbox");
        this.modelLoaded = true;
      }
    },
    onContextmenu(event) {
      mongeApiMlib.onContextmenu(event);
    },
    resize() {
      mongeApiMlib.resize();
    },
    async closeMap() {
      mongeMutations.setHasDwg(false);
      mongeMutations.setModelPageFileName();
      mongeApiMlib.closeMap();
    }
  }
};
</script>

<style lang="scss" scoped>
#modelView{
  height: 100vh;
  width: 100vw;
  position: relative;
  user-select: none;
  overflow: hidden;
  background: #fff;
  display: flex;
  flex-direction: row;
  .column-left {
    height: 100vh;
    background-color: #eee;
    position: relative;
    i{
      cursor: pointer;
      font-size: 20px;
      position: absolute;
      z-index: 4;
      top: 10px;
      right: 10px;
      color: #fff;
    }
    .viewDwg {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      overflow: hidden;
    }
  }
  .column-right {
    position: relative;
    height: 100vh;
    background-color: #fff;
    box-sizing: border-box;
    overflow: hidden;
    .viewModel{
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      overflow: hidden;
    }
  }
  .splitpanes--vertical .splitpanes__pane{
    transition:none
  }
}
</style>
